// services
import {
  cookieStorage,
  COOKIE_ACCESS_TOKEN,
  COOKIE_PKG,
  COOKIE_REFRESH_TOKEN
} from 'services/cookie';

// libraries
import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

const source = axios.CancelToken.source();

export const clearUserToken = () => {
  cookieStorage.clearAllCookies();
  window.location.href = '/sign-in';
};

class AxiosInstanceCreator {
  Axios: AxiosInstance;

  constructor(config?: AxiosRequestConfig) {
    this.Axios = axios.create({
      // baseURL: 'http://localhost:8070/api/v1',
      // baseURL: 'https://admin-api.pkg4-4s-fadhilidev.com/api/v1',
      baseURL: 'https://admin-api.fgiprfid.com/api/v1',
      withCredentials: true,
      ...config
    });

    this.Axios.defaults.cancelToken = source.token;

    this.interceptors();
  }

  interceptors() {
    this.Axios.interceptors.request.use(async (config) => {
      const token = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

      if (!config.headers['Authorization']) {
        Object.assign(config.headers, {
          Authorization: `Bearer ${token}`
        });

        // sessionStorage.getItem(COOKIE_ACCESS_TOKEN);

        // if (token !== null && token !== 'undefined' && token !== undefined) {
        //   const refreshToken = cookieStorage.getCookie(COOKIE_REFRESH_TOKEN);
        //   const decodedToken = jwtDecode(token).exp;
        //   const currentTime = dayjs().unix();
        //   const isExpired = decodedToken < currentTime;

        //   // 토큰 만료시 재발급 함수 추가
        //   if (refreshToken && isExpired) {
        //     try {
        //       const response = await axios.get(import.meta.env.VITE_API_URL + `/v1/api/token`, {
        //         headers: {
        //           REFRESH_TOKEN: `Bearer ${refreshToken}`,
        //           Authorization: `Bearer ${token}`
        //         }
        //       });

        //       const { ACCESS_TOKEN, REFRESH_TOKEN } = response?.data.resultObject;

        //       cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, ACCESS_TOKEN);
        //       cookieStorage.setCookie(COOKIE_REFRESH_TOKEN, REFRESH_TOKEN);

        //       Object.assign(config.headers, {
        //         Authorization: `Bearer ${ACCESS_TOKEN}`
        //       });
        //     } catch (e) {
        //       console.log('== 토큰 재발급 에러 발생 == : ', e);

        //       clearUserToken();
        //     }
        //   } else {
        //     Object.assign(config.headers, {
        //       Authorization: `Bearer ${token}`
        //     });
        //   }
        // }
      }

      if (!config.headers['Content-Type']) {
        Object.assign(config.headers, {
          'Content-Type': 'application/json'
        });
      }

      if (!config.headers['Accept']) {
        Object.assign(config.headers, {
          Accept: 'application/json'
        });
      }

      return config;
    });

    this.Axios.interceptors.response.use(
      (res) => {
        // res.headers
        if (res.data.code && res.data.code !== 200) {
          throw new Error(res.data.message).message;
        }

        return res;
      },

      (error) => {
        if (error.response && error.response.status === 504) {
          console.log('서버가 일시적으로 사용 불가능합니다.');

          const result = {
            ...error.response.data,
            message: '서버가 일시적으로 사용 불가능합니다. 잠시 후 다시 시도해주세요.',
            statusCode: 504
          };

          throw result;
        }

        if (axios.isCancel(error)) {
          clearUserToken();

          throw error;
        } else {
          const result = {
            ...error.response.data,
            message: error
          };

          throw result;
        }
      }
    );
  }

  create() {
    return this.Axios;
  }
}

export default AxiosInstanceCreator;
